import fs from 'fs';
import path from 'path';
import matter from 'gray-matter';
import { NextPageWithLayout } from './_app';
import Layout from 'components/Layout';
import TextPage from 'components/TextPage';
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations';
import { GetServerSideProps } from 'next';

interface IContactProps {
  content: string | null;
  frontmatter: { title: string };
}

const Contact: NextPageWithLayout<IContactProps> = ({
  frontmatter: { title },
  content,
}) => {
  return <TextPage title={title} content={content} />;
};

Contact.getLayout = (page: React.ReactElement) => (
  <Layout
    navBarClassName="bg-white py-6"
    titleProduction="meta_title_contact"
    titleStaging="Contact"
    metaDescriptionProd="meta_description_production_contact"
    metaDescriptionStaging="Allmyles API showcase contact is for developers who are willing to ask staging access"
    canonicalProd="https://tipptour.com/contact"
    canonicalStaging="https://showcase.allmyles.com/contact">
    {page}
  </Layout>
);
export default Contact;

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  const env = process.env.NEXTJS_NODE_ENV === 'production' ? 'prod' : 'dev';
  try {
    const markdownWithMeta = fs.readFileSync(
      path.join(
        process.cwd(),
        `assets/localization/contact/${env}/${locale}.md`,
      ),
    );
    const { data: frontmatter, content } = matter(markdownWithMeta);
    return {
      props: {
        ...(await serverSideTranslations(locale || 'en')),
        frontmatter: JSON.parse(JSON.stringify(frontmatter)),
        content: content,
      } as IContactProps,
    };
  } catch (err) {
    return {
      props: {
        ...(await serverSideTranslations(locale || 'en')),
        frontmatter: { title: '' },
        content: null,
      } as IContactProps,
    };
  }
};
